import React from 'react';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import GoogleScholarSearchForm from "../Component/GoogleScholarSearchForm";
import CatalogSearchForm from "../Component/HUCatalog";

export default class SearchPanel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      searchQuery: "",
      searchCatalogQuery: ""
    }

    this.ScholarHandleChanged = this.ScholarHandleChanged.bind(this);
    this.CatalogHandleChanged = this.CatalogHandleChanged.bind(this);
    this.ScholarHandleClicked = this.ScholarHandleClicked.bind(this);
    this.CatalogHandleClicked = this.CatalogHandleClicked.bind(this);
  }

  ScholarHandleChanged(event) {
    this.setState({
      searchQuery: event.target.value
    });
  }

  CatalogHandleChanged(event) {
    this.setState({
      searchCatalogQuery: event.target.value
    });
  }

  ScholarHandleClicked() {
    var searchQuery = this.state.searchQuery;
    window.open(
      'https://scholar.google.com/scholar?q=' + searchQuery,
      '_blank'
    );
  }

  CatalogHandleClicked() {
    var searchCatalogQuery = this.state.searchCatalogQuery;
    window.open(
      'https://catalog.habib.edu.pk/cgi-bin/koha/opac-search.pl?q=' + searchCatalogQuery,
      '_blank'
    );
  }

  handleScholarKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      this.ScholarHandleClicked();
    }
  }

  handleCatalogKeyPress(event) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
      this.CatalogHandleClicked();
    }
  }
  
  
  render() {
   

    return  (
      <section className='search-area'>
        
    
    
      <div className='container'>
          <div className="row justify-content-center">
            <div className='col-lg-10 search-inner'>
              {/* <h2>Library & Academic Support</h2> */}
              <div className='search-inner-content'>
                <h4>Opening the door to knowledge.</h4>
                <p>Search Your Favourite Book, Research Papers and much more</p>
                <div className='tab-search'>
                  <Tabs
                      defaultActiveKey="CatalogSearch"
                      id="uncontrolled-tab-example"
                     
                      >
                      <Tab eventKey="CatalogSearch" title="Catalog Search">
                        {/* <Form>
                            <InputGroup>
                              <Form.Control
                                  placeholder="Type book name, author or ID"
                                  aria-label="Type book name, author or ID"
                                  aria-describedby="basic-addon2"
                                  type="text" value={this.state.searchCatalogQuery} onChange={this.CatalogHandleChanged.bind(this)}/>
                              <Button variant="outline-secondary" id="button-addon2" onClick={this.CatalogHandleClicked.bind(this)}>
                              <Button variant="outline-secondary" id="button-addon2" onClick={this.CatalogHandleClicked.bind(this)}>
                                 <img src='assets/img/search-icon.svg' alt=""/> 
                              </Button>
                            </InputGroup>
                        </Form> */}
                        <CatalogSearchForm />
                      </Tab>
                      <Tab eventKey="GoogleScholar" title="Google Scholar">
                        {/* <Form>
                            <InputGroup>
                              <Form.Control
                                  placeholder="Type book name, author or ID"
                                  aria-label="Type book name, author or ID"
                                  aria-describedby="basic-addon2"
                                  type="text" value={this.state.searchQuery} onChange={this.ScholarHandleChanged.bind(this)}/>
                              <Button variant="outline-secondary" id="button-addon2" onClick={this.ScholarHandleClicked.bind(this)}>
                                 <img src='assets/img/search-icon.svg' alt=""/> 
                              </Button>
                              
                            </InputGroup>
                        </Form> */}
                        <GoogleScholarSearchForm />
                      </Tab>
                      {/* <Tab eventKey="CovidLearingContinuity" title="Covid & Learing Continuity">
                         <div className='covid-content'>
                              <p> Habib University Library has compiled list of resources for learning continuity. Click here to view the list
                              </p>
                         </div>
                      </Tab> */}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>
    );
  }
}